import React, { useEffect, useState } from 'react';
import { fire } from '../../api/firebaseEnv';
import { Button } from "devextreme-react/button";
import { SelectBox } from "devextreme-react/select-box";
import * as DinamicQueries from "../../api/DinamicsQuery";
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    HeaderFilter,
    LoadPanel,
    Selection,
} from "devextreme-react/data-grid";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();
const getOpenAIResponse = httpsCallable(functions, "getOpenAIResponse");




const RutasIa = () => {
    const [regiones, setRegiones] = useState([]);
    const [establecimientos, setEstablecimientos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [filterUsers, setFilterUsers] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const [selectedStore, setSelectedStore] = useState([])
    const [load, setLoad] = useState(false)
    const allowedPageSizes = [8, 12, 20];

    const [resultadoIa, setResultadoIa] = useState(null);
    const [errorIa, setErrorIa] = useState(null);
    const [loadingIa, setLoadingIa] = useState(false);

    const isDisabled = selectedUsers.length === 0 || selectedStore.length === 0;

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("userData"));
        setRegiones(userData.region);
        getUserAssigned(userData.uid);
    }, [])

    const getUserAssigned = (uid) => {
        let usuariosFinales = []

        fire.collection(`/Usuarios/${uid}/usuariosAsignados`).get().then((resp) => {
            resp.forEach((CadaUsuario) => {
                const tempUser = CadaUsuario.data();
                tempUser.nombre = tempUser.nombre + tempUser.apellido
                usuariosFinales = [...usuariosFinales, CadaUsuario.data()]
                setUsuarios(usuariosFinales)
            })
        }).catch((error) => {
            console.log("🚀 ~ fire.collection ~ error:", error)
        })
    };

    const searchEstablecimientos = (e) => {
        if (e.value != "") {
            setSelectedStore([])
            setSelectedUsers([])

            DinamicQueries.getDataWithParameters("callProcedure", "analytics/", {
                method: "sp_get_storeWithRegion",
                params: {
                    nameRegion: e.value
                }
            }).then((establecimientos) => {
                const TempUsers = usuarios.filter((usuario) => usuario.region.includes(e.value));
                setFilterUsers(TempUsers)

                const temporalEstfilter = establecimientos.data.filter((x) => x.LAT !== null && x.LNG !== null);
                const estFinal = temporalEstfilter.splice(0, 50);
                console.log("🚀 ~ searchEstablecimientos ~ estFinal:", estFinal.length)
                setEstablecimientos(estFinal)
            })
        }
    };

    const handleOptionChange = (e) => {
        setSelectedStore(e.selectedRowsData)
    };

    const handleOptionChangeUser = (e) => {
        setSelectedUsers(e.selectedRowsData)
    };

    async function chunkArray(array, chunk_size) {
        const results = [];
        for (let i = 0; i < array.length; i += chunk_size) {
            results.push(array.slice(i, i + chunk_size));
        }
        return results;
    }

    async function dividePorUsuario(usuarios, chunkSize) {
        const chunks = [];
        let currentChunk = [];
        let currentLength = 0;

        usuarios.forEach((usuario, index) => {
            const jsonUsuario = JSON.stringify(usuario);
            if (currentLength + jsonUsuario.length > chunkSize) {
                chunks.push(currentChunk.join('\n'));
                currentChunk = [];
                currentLength = 0;
            }
            currentChunk.push(jsonUsuario);
            currentLength += jsonUsuario.length;
        });

        if (currentChunk.length > 0) {
            chunks.push(currentChunk.join('\n'));
        }

        return chunks;
    }

    const generarRutaIA = async () => {
        setLoadingIa(true);
        setErrorIa(null);
        setResultadoIa(null);
    
        try {
            const prompt = [
                {
                    role: "system",
                    content: "Eres un asistente experto en logística para una empresa de marketing. Tu tarea es asignar rutas óptimas de visitas a establecimientos. Debes distribuir los establecimientos entre los promotores seleccionados de forma equilibrada. Incluye el nombre del usuario, la cantidad de tiendas asignadas, y una lista de nombres de tiendas para cada uno."
                },
                {
                    role: "user",
                    content: `Estos son los usuarios disponibles:\n${selectedUsers.map(u => `- ${u.nombre}`).join('\n')}\n\nY estos son los establecimientos:\n${selectedStore.map(s => `- ${s.NAME}`).join('\n')}\n\nAsigna las rutas de forma equitativa entre los usuarios.`
                }
            ];
    
            console.log("Prompt generado:", prompt);
    
            const response = await getOpenAIResponse({ conversation: prompt });
    
            console.log("Respuesta de la IA:", response);
    
            setResultadoIa(response.data);
        } catch (error) {
            console.error("Error al generar la ruta:", error);
            setErrorIa("Hubo un problema al generar la ruta.");
        } finally {
            setLoadingIa(false);
        }
    };      

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <SelectBox
                        className="SelectBoxR mb-2"
                        placeholder="Seleccione una región"
                        label="Región"
                        dataSource={regiones}
                        onValueChanged={(e) => searchEstablecimientos(e)}
                        searchEnabled={true}
                    />
                </div>
            </div>

            <div className="row mx-5" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="col-md-6 mt-2">
                    <div className={'dx-card'} style={{ padding: "20px", borderRadius: "15px" }}>
                        <h6 className="title">Establecimientos</h6>
                        <DataGrid
                            className="tabla-user"
                            dataSource={establecimientos}
                            showBorders={true}
                            remoteOperations={true}
                            defaultFocusedRowIndex={0}
                            style={{ height: "65vh", width: "100%" }}
                            keyExpr="ID_FB"
                            onSelectionChanged={(e) => handleOptionChange(e)}
                            wordWrapEnabled={true}
                        >
                            <FilterRow visible={true} />
                            <Selection mode="multiple" />
                            <LoadPanel enabled />
                            <Paging defaultPageSize={20} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                            />
                            <HeaderFilter visible={true} />

                            <Column
                                caption={"ID"}
                                dataField={"ID_STORE"}
                                width={100}
                            />

                            <Column
                                dataField={"NAME"}
                                caption={"Nombre Establecimiento"}
                                dataType="string"
                            />
                        </DataGrid>
                    </div>
                </div>

                <div className="col-md-6 mt-2">
                    <div className={'dx-card'} style={{ padding: "20px", borderRadius: "15px" }}>
                        <h6 className="title">Usuarios</h6>
                        <DataGrid
                            className="tabla-user"
                            dataSource={filterUsers}
                            showBorders={true}
                            remoteOperations={true}
                            defaultFocusedRowIndex={0}
                            style={{ height: "65vh", width: "100%" }}
                            keyExpr="uid"
                            wordWrapEnabled={true}
                            onSelectionChanged={(e) => handleOptionChangeUser(e)}
                        >
                            <FilterRow visible={true} />
                            <Selection mode="multiple" />
                            <LoadPanel enabled />
                            <Paging defaultPageSize={20} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                            />
                            <HeaderFilter visible={true} />

                            <Column
                                caption="Nombre"
                                dataField="nombre"
                                dataType="string"
                            />
                            <Column
                                caption="Region"
                                dataField="region"
                                dataType="string"
                            />
                        </DataGrid>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                <Button
                    className="btn-agregar mt-3"
                    style={{ width: "500px" }}
                    disabled={isDisabled || load || loadingIa}
                    onClick={generarRutaIA}
                >
                    {loadingIa ? "Generando ruta..." : "Generar Ruta"}
                </Button>

                </div>
                {resultadoIa && (
                    <div className="card mt-4 mb-5 px-4 py-3" style={{ maxWidth: "90%", margin: "0 auto" }}>
                        <h5 className="mb-3 text-primary">Resultado IA:</h5>
                        <pre className="text-dark" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                            {typeof resultadoIa === "string" ? resultadoIa : JSON.stringify(resultadoIa, null, 2)}
                        </pre>
                    </div>
                )}

                {errorIa && (
                    <div className="alert alert-danger mt-4" style={{ maxWidth: "90%", margin: "0 auto" }}>
                        {errorIa}
                    </div>
                )}
            </div>
        </>
    )
}

export default RutasIa